import { type MCPServerInfo } from '../../types';

const AshbyNatomaServer: MCPServerInfo = {
  serverId: 'ASHBY_NATOMA',
  name: 'Ashby (Natoma)',
  slug: 'ashby-natoma',
  description:
    'Ashby MCP Server — manage jobs, candidates, applications, and interviews in Ashby',
  source: {
    sourceType: 'REPOSITORY',
    type: 'NATOMA',
    repositoryUrl: 'https://github.com/natomalabs/ashby-mcp-server',
    commitSha: 'b7b6d8e0',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['ashbyApiKey'],
    properties: {
      ashbyApiKey: {
        type: 'string',
        description:
          'Ashby API key (generate in Ashby → Admin → API Keys). Scope the key to only the permissions end users should have.',
        sensitive: true
      }
    }
  },
  deprecated: true
};

export default AshbyNatomaServer;
